<!-- mock各种b2c消息 -->
<template>
  <div v-if="enabled" class="mock-pad">
    <div class="tit animate__animated animate__headShake animate__infinite">mock message</div>
    <ul>
      <li @click="makeEvent(EVENT.TYPING, {typing: true})">EVENT-手动输入中</li>
      <li @click="sendMsg(IMSDKType.MSG_TEXT)">B2C-文本消息</li>
      <li @click="sendMsg(IMSDKType.MSG_IMAGE)">B2C-图片消息</li>
      <li @click="sendMsg(IMSDKType.MSG_FILE)">B2C-文件消息</li>
      <li @click="sendMsg(IMSDKType.MSG_VOICE)">B2C-语音消息</li>
      <li @click="sendMsg(IMSDKType.MSG_IMAGE_TEXT)">B2C-图文消息</li>
      <li @click="sendMsg('leave_form_msg')">B2C-留言消息</li>
      <li @click="sendMsg(IMSDKType.MSG_QDXML)">B2C-XML消息</li>
      <li @click="sendMsg(IMSDKType.MSG_FEED_BACK)">满意度-类型1</li>
      <li @click="changeKF">B2C-切换客服</li>
      <li @click="navMenu">自助导航-XML</li>
      <li @click="sendRobotMsg('htmlmsg')">机器人消息-htmlmsg</li>
      <li @click="sendRobotMsg('freemsg')">机器人消息-freemsg</li>
      <li @click="sendRobotMsg('batchmsg')">机器人消息-batchmsg</li>
      <li @click="sendRobotMsg('robotform')">机器人消息-form</li>
      <li @click="sendRobotMsg('qlist')">招商信诺</li>
      <li @click="sendRobotMsg('drawer_group')">机器人消息-抽屉聚合</li>
      <li @click="sendRobotMsg('drawer_nogroup')">机器人消息-抽屉不聚合</li>
      <li @click="sendRobotMsg('bubble_group')">机器人消息-气泡聚合</li>
      <li @click="sendRobotMsg('bubble_nogroup')">机器人消息-气泡不聚合</li>
      <li @click="sendRobotMsg('card')">机器人消息-横滑卡片</li>
      <li @click="sendRobotMsg('node')">机器人消息-物流节点</li>
      <li @click="sendMsg(IMSDKType.MSG_ROBOT_NAV)">机器人导航消息</li>
      <li @click="uploadLongText()">上传长文本</li>
      <li @click="downloadLongText()">下载长文本</li>
      <li @click="sendQDXML()">发送企点结构化XML消息</li>
      <li @click="sendMsg(IMSDKType.MSG_THIRD_MSG)">b2c-第三方消息-满意度</li>
    </ul>
  </div>
</template>

<script>
import StringUtils from '@/utils/string';
import feedbackType1 from '@/components/MockMsg/mock/feedbackType1';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';
import { getRobotNavContent } from './data/robot-nav-mock.js';

import { imgTxtXML } from './data/img-txt-xml';
import { navMenuXML, businessMsg } from './data/nav-menu-xml';
import { changeKFXML } from './data/change-kf-xml';
import { drawerList, bubbleList, cardList, nodeList, drawerNoGroupList, bubbleNoGroupList } from './data/robot_model_mock';
const imsdk = IMSDK.create();

export default {
  inject: ['MsgType', 'IMSDKType'],
  props: {
    to: {
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      enabled: false, // 是否启用mock
      EVENT: IMSDK.EVENT,
    };
  },
  mounted() {
    // 仅本地开发启用
    if (process.env.NODE_ENV === 'development') {
      this.enabled = true;
    }
  },
  methods: {
    // 模拟B2C发送各种消息
    sendMsg(type, xml = null) {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type,
        time: Date.now(),
        status: 0,
        from: to,
      };

      if (type === this.IMSDKType.MSG_TEXT) {
        Object.assign(msg, {
          content: `随机文本${Math.random().toString(36)
            .substring(2)}`,
        });
      }

      if (type === this.IMSDKType.MSG_IMAGE) {
        Object.assign(msg, {
          content: 'https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-189792930-E59538E23B28257858A4768105725293/0',
          uuid: msg.seq,
          name: '1-115.jpg',
          size: 144836,
          width: 1080,
          height: 1370,
        });
      }

      if (type === 'leave_form_msg') {
        // 因为改数据类型是通过ajax拉表单配置的，没办法在这里mock
        // mock 可以打开 src/components/MockMsg/index.vue 注释
        Object.assign(msg, {
          content: '',
        });
        this.$Toast({ text: '暂不支持', type: 'error' });
        return false;
      }

      if (type === this.IMSDKType.MSG_FILE) {
        Object.assign(msg, {
          content: 'blob:http://localhost:8080/a1b9bb6c-3210-419d-b46b-862b6546954d',
          uuid: 'blob',
          name: 'test.jpg',
          size: 162356,
          format: 'image/jpeg',
        });
      }

      if (type === this.IMSDKType.MSG_VOICE) {
        Object.assign(msg, {
          content: 'https://bqq.gtimg.com/CDN/source/audio/dida.mp3',
          uuid: msg.seq,
          length: 3,
          size: 3829,
        });
      }

      if (type === this.IMSDKType.MSG_IMAGE_TEXT) {
        this.$Toast({ text: '暂不支持', type: 'error' });
        return false;
      }

      if (type === this.IMSDKType.MSG_QDXML) {
        if (!xml) {
          // eslint-disable-next-line no-param-reassign
          xml = imgTxtXML;
        }

        Object.assign(msg, {
          content: {
            content: xml,
          },
        });
      }

      // 测试机器人导航消息
      if (type === this.IMSDKType.MSG_ROBOT_NAV) {
        // 机器人导航类型  0，按钮型 1，简单文本型 2，基础型 3，多主题型 4，小卡片型 5，组合型 6，多级基础型
        Object.assign(msg, {
          content: {
            content: getRobotNavContent(Date.now() % 7),
          },
        });
      }
      // 满意度
      if (type === this.IMSDKType.MSG_FEED_BACK) {
        Object.assign(msg, {
          content: feedbackType1,
          msgHead: {
            uint64_msg_sync_seq: 111111,
            uint64_side_sync_seg: 222222,
            uint64_msg_roaming_seq: 333333,
            msg_type_info: {
              msg_c2c_info: {
                uint64_from_aid: 4444,
                uint64_to_aid: 5555,
              },
            },
          },
        });
      }

      // 重构满意度(第三方)
      if (type === this.IMSDKType.MSG_THIRD_MSG) {
        Object.assign(msg, {
          content: {
            crmFlag: 60,
            content: 'uk=92D8F3F949001CE76007B9EC1DD0AE30_86400_1670987498',
          },
        });
      }
      this.mackB2CMsg(msg);
    },

    // 模拟B2C消息
    mackB2CMsg(msg) {
      const to = this.to.id;

      const msgList = {
        [to]: [msg],
      };
      console.log('mock', msgList);
      imsdk.emit(IMSDK.EVENT.MESSAGE_RECEIVED, msgList);
    },

    changeKF() {
      this.sendMsg(this.IMSDKType.MSG_QDXML, changeKFXML);
    },

    /**
     * 模拟上屏机器人消息
     */
    sendRobotMsg(subType) {
      const to = this.to.id;

      const msg = {
        seq: StringUtils.generateUUID(),
        type: this.IMSDKType.MSG_ROBOT,
        time: Date.now(),
        status: 0,
        from: to,
        crm: {
          msg_webim_extra_data: { bytes_wpaid: '', uint64_robotid: '' }, str_session_id: '',
        },
      };
      if (subType === 'htmlmsg') {
        // 消息内容
        msg.content = {
          type: 5,
          content: '这是html消息<a href="https://qq.com"><span>腾讯</span></a><br><br><br><br><br><br><br><br><br><br><br><br><br>哈哈哈<br><br><br><br><br><br><br>哈哈哈',
        };
      }

      if (subType === 'freemsg') {
        const demoData = [
          // 普通
          {
            type: 4,
            content: '这是html消息<a href="https://qq.com">哈哈哈</a><img src="https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-1762026921-4F9CA1576DF16EFD772434DD7EB245FB/0">',
          },
          // btnList快捷回复
          {
            type: 4,
            content: '<a href="https://cloud.tencent.com/">腾讯云</a>提供三种类型的云服务器购买方式：包年包月、按量计费和竞价实例。<img src="https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-1762026921-4F9CA1576DF16EFD772434DD7EB245FB/0">\n<a href="qdweb://webim/message/sendc2b?content=有" class="quick-relply-btn">有</a><a href="qdweb://webim/message/sendc2b?content=没有" class="quick-relply-btn">没有</a>',
          },
          // qlist
          {
            type: 4,
            msgType: 2,
            content: '您可能还想问<a href="qdweb://webim/message/sendc2b?content=酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间">酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间</a><a href="qdweb://webim/message/sendc2b?content=介绍一下酒店的餐厅">介绍一下酒店的餐厅</a><a href="qdweb://webim/message/sendc2b?content=酒店游泳池地址及开放时间">酒店游泳池地址及开放时间</a>',
          },
        ];
        msg.content = demoData[Date.now() % (demoData.length)];
      }

      if (subType === 'batchmsg') {
        msg.content = {
          type: 6,
          pagecount: 5,
          answer: {
            type: 4,
            datatype: 4,
            msgType: 1,
            content: '1.场景释义：\n机构老师将可约课的日程透出，让学员通过预约的方式，根据自己的情况进行课程、时间的预约<img src="https://p.qpic.cn/qidian_pic/2852199330/2020112872464fe1e0fcb8f207b12f22684eb7cc/0" alt="插图" data-alt="图片插入"><img src="https://p.qpic.cn/qidian_pic/2852199330/20201128e76fa78b5c0c9094b86b827ce084b5e1/0" alt="插图" data-alt="图片插入">',
          },
          answer_type: 1,
          list: [{
            text: '1232435',
            itemtype: '333',
            key: '345',
          }, {
            text: '653133214',
            itemtype: '333',
            key: '345',
          }, {
            text: 'fsgsaha',
            itemtype: '333',
            key: '345',
          }, {
            text: 'hasye色啊塔塔',
            itemtype: '333',
            key: '345',
          }, {
            text: '嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊',
            itemtype: 'c2b',
            key: '345',
          }, {
            text: '很短了',
            itemtype: 'c2b',
            key: '345',
          }, {
            text: '很短了',
            itemtype: 'c2b',
            key: '345',
          }, {
            text: '很短了',
            itemtype: 'c2b',
            key: '345',
          }],
        };
      }

      if (subType === 'robotform') {
        msg.type = this.IMSDKType.MSG_ROBOT_FORM;
        msg.content = {
          content: [{ fieldName: '字段1', fieldType: 1, options: { instances: [{ name: '自己查询', id: '1082', dictId: '267', type: 'user' }, { name: '已申请', id: '1081', dictId: '267', type: 'user' }, { name: '准备申请', id: '1080', dictId: '267', type: 'user' }] }, required: true, slotDefId: 207, slotName: '金牌商标判断' }, { fieldName: '城市', fieldType: 2, options: { instances: [] }, required: true, slotDefId: 175, slotName: '所在城市' }, { fieldName: '城市', fieldType: 3, options: { instances: [] }, required: true, slotDefId: 15, slotName: '所在城市' }],
        };
      }

      if (subType === 'qlist') {
        const demoData = {
          type: 2,
          description: [
            { text: '您可以 ' },
            { text: '点击此处', url: 'https://member.cignacmb.com/mb-web/account/index.html#!/znkfLogin/JF' },
            { text: ' 操作在线交费。' },
          ],
          questions: [
            { text: '指定交费日' },
            { text: '宽限期是指什么' },
          ],
        };
        msg.content = demoData;
      }

      if (subType === 'drawer_group') {
        msg.content = drawerList.data;
      }

      if (subType === 'bubble_group') {
        msg.content = bubbleList.data;
      }
      if (subType === 'card') {
        msg.content = cardList.data;
      }
      if (subType === 'node') {
        msg.content = nodeList.data;
      }
      if (subType === 'drawer_nogroup') {
        msg.content = drawerNoGroupList.data;
      }

      if (subType === 'bubble_nogroup') {
        msg.content = bubbleNoGroupList.data;
      }
      if (subType !== 'robotform') {
        // 单条消息满意度
        msg.content.vote = {
          active: ['up', 'down', ''][Date.now() % 3],
          id: msg.seq,
          expiredIntervalTime: 86400000,
          robotId: 922223543,
          button: [{ key: 'up' }, { key: 'down' }],
        };
      }


      this.mackB2CMsg(msg);
    },

    /**
     * 模拟消息
     */
    makeEvent(event, options) {
      imsdk.emit(event, options);
    },

    /**
     * 自助导航
     */
    navMenu() {
      this.sendMsg(this.IMSDKType.MSG_QDXML, navMenuXML);
    },

    /**
     *
     */
    async uploadLongText() {
      const longText = navMenuXML;
      const rs = await SDKUtils.uploadLongText(longText);
      console.log('[uploadLongText-result]', rs);
    },

    /**
     * 下载长文本
     */
    async downloadLongText() {
      const url = await SDKUtils.getDownloadUrl({
        path: '8b497251-475a-4d8b-b1d7-1fd7c3ecc259',
      }, IMSDK.OBJTYPES.OBJ_LONGTEXT);
      const rs = await this.$ajax.get(url);
      console.log('[downloadLongText-result]', url, rs.data);
    },

    /**
     * 发送QD结构化消息
     */
    sendQDXML() {
      // 发送存在问题。
      this.$parent.sendQDXMLMessage({
        qdxml: {
          content: businessMsg,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mock-pad {
  position: fixed;
  top: 100px;
  left: 0;
  border-radius: 0 10px 10px 0;
  background: #18f;
  color: #fff;
  font-size: 14px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  overflow: hidden;
  transition: all 0.3s;

  &:hover {
    width: 200px;
    height: 80vh;
    overflow-y: auto;
  }

  .tit {
    padding: 10px;
    font-weight: 600;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      padding: 14px;
      border-bottom: 1px dashed #ddd;
      cursor: pointer;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
